<div class="navbar-top" [ngClass]="rossConfig.layout.navbar.secondaryBackground">

    <div class="logo">
        <a [routerLink]="['/pages']" class="logo-link">
            <img class="logo-icon" src="assets/img/logofta_w.svg" alt="FTAGo logo">
          </a>
    </div>

    <div class="buttons">

        <button mat-icon-button class="toggle-sidebar-folded"
                (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button mat-icon-button class="toggle-sidebar-opened"
                (click)="toggleSidebarOpened()" fxHide.gt-md>
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>

    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="rossConfig.layout.navbar.primaryBackground"
     rossPerfectScrollbar [rossPerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user" fxLayout="column" [ngClass]="rossConfig.layout.navbar.secondaryBackground">

        <div style="text-align: center; margin-bottom: -5px;" class="h3 username">{{currentUser.user_nombre}}</div>
        <div class="h5 email hint-text mt-8">{{currentUser.user_profile}}</div>
        <div class="avatar-container" style="background-color: rgb(255, 255, 255);" (click)="openProfileImageDialog()" matTooltip="Editar imagen de perfil">
            <img
            class="avatar"
            [ngClass]="{'apto': aptitud === 1, 'apto2': aptitud === 0}"
            [src]="profileImageUrl || 'assets/img/user.svg'"
            alt="User's avatar"
          />
          <mat-icon class="avatar-icon">add_circle</mat-icon>
      
        </div>

    </div>

    <div class="navbar-content">
        <ross-navigation class="material2" layout="vertical"></ross-navigation>
    </div>

</div>
